import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import Home from './Pages/Home';
import About from './Pages/About';
import Solutions from './Pages/Solutions';
import Contact from './Pages/Contact';
import Distributors from './Pages/Distributors';
import MessageBoard from './Pages/MessageBoard';

import Kylendar from './Pages/Kylendar';
import KylendarOverview from './Pages/KylendarOverview';
import KylendarV2 from './Pages/KylendarV2';
import SkuDock from './Pages/SkuDock';
import Auth from './Pages/Auth';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import HelpCenter from './Pages/HelpCenter';
import ForgotPassword from './Pages/ForgotPassword';
import ThankYou from './Pages/ThankYou';
import Products from './Pages/Products';
import Templates from './Pages/Templates';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';


function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <LanguageProvider>
          <Router>
            <Layout>
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/about" element={<About />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/distributors" element={<Distributors />} />
              <Route path="/message-board" element={<MessageBoard />} />

              <Route path="/kylendar" element={<KylendarOverview />} />
              <Route path="/kylendar/v1" element={<Kylendar />} />
              <Route path="/kylendar/v2" element={<KylendarV2 />} />
              <Route path="/skudock" element={<SkuDock />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/help-center" element={<HelpCenter />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/thank-you" element={<ThankYou />} />
              </Routes>
            </Layout>
          </Router>
        </LanguageProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
